import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { GridItem } from "./LeadCompany.styled";

const Header = (props) => {
  const {
    t,
    title,
    align,
    alignContent,
    borderRadius,
    backgroundColor,
    color,
    fontWeight,
  } = props;

  return (
    <GridItem
      fontSize="16px"
      fontWeight={fontWeight}
      backgroundColor={backgroundColor}
      color={color}
      textAlign={align}
      alignContent={alignContent}
      leftRadius={borderRadius === "left" ? "5px" : "0px"}
      rightRadius={borderRadius === "right" ? "5px" : "0px"}
    >
      {t(title)}
    </GridItem>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  fontWeight: PropTypes.string,
  alignContent: PropTypes.string,
};

Header.defaultProps = {
  backgroundColor: "#008395",
  color: "#fff",
  fontWeight: "700",
  alignContent: "normal",
};
export default withTranslation()(Header);
